export default __webpack_public_path__ + "static/media/stok.a5b2c482.png";